// src/App.js
import React from 'react';
import AdminPanel from './AdminPanel';
import MainApp    from './MainApp';

function App() {
  const path = window.location.pathname;
  // Render CMS when at /admin (or still respond to /arranigoe.admin if you want)
  if (path === '/admin' || path === '/arranigoe.admin') {
    return <AdminPanel />;
  }
  // Otherwise render your normal app
  return <MainApp />;
}

export default App;